import styled from "styled-components";

export const TextEditContainer = styled.div`
  background: #fff;
  width: 100%;

  border: 1px solid #e9ebf8;
  box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25);
  border-radius: 16px;
  margin-top: 48px;
  padding: 60px 60px 40px 60px;
  overflow-y: auto;
  @media (max-width: 1024px) {
    padding: 32px 16px;
    box-shadow: none;
    background-color: transparent;
    border: none;
  }
  .wrapper-class {
    width: auto;
  }
  @media (max-width: 1024px) {
  }
`;

export const VoiceContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  position: relative;
  & .audio-container {
    flex: 1;
    & .controller {
      & .speed {
        width: 50px;
      }
    }
    @media (max-width: 1024px) {
      & > div {
        flex-direction: column;
        gap: 13px;
      }
    }
    & > div wave {
      overflow: hidden hidden !important;
    }
    & .button {
      width: 48px;
      height: 48px;
      /* background: linear-gradient(
        180deg,
        #4d77ac 3.65%,
        rgba(98, 158, 232, 0.8) 49.48%,
        #4d77ac 92.71%
      );
     
      border: 2px solid transparent; */
      background: linear-gradient(
        180deg,
        #4d77ac 3.65%,
        rgba(98, 158, 232, 0.8) 49.48%,
        #4d77ac 92.71%
      );
      border-radius: 50%;
      &:hover {
        background: white;
        border: 1px solid #4d77ac;
      }
      & svg {
        width: 48px;
        height: 48px;
        /* border: 2px solid green;
        border-radius: 50%; */
        color: white !important;
        fill: white !important;
        &:hover {
          color: #4d77ac !important;
          fill: #4d77ac !important;
        }
      }
    }
  }
  & > div {
    @media (max-width: 1024px) {
      & .button {
        width: 32px;
        height: 32px;
      }
    }
  }

  @media (max-width: 1440px) {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
  @media (max-width: 1024px) {
    flex-wrap: wrap;
    & > div {
      flex-direction: column;
      width: 100%;
    }
  }

  @media (max-width: 1440px) {
    flex-direction: column;
    align-items: center;
  }
  .title {
    display: flex;
    direction: rtl;
    align-items: center;
    justify-content: center;
    flex: 1;
    /* flex-direction: column;
    justify-content: start; */
    @media (max-width: 1024px) {
      display: flex;
      justify-content: flex-start;
      flex-direction: row;
      overflow: hidden;
      margin-bottom: 16px;
    }

    @media (max-width: 1440px) {
      width: 100%;
    }
    button {
      scale: 0.8;
    }
    & .titleEdit {
      margin-left: 12px;
      display: flex;
      align-items: center;
      padding: 10px 10px 10px 32px;
      flex: 2;
      transition: 0.5s;
      @media (max-width: 1024px) {
        padding: 0;
      }
      input {
        border: none;
        position: absolute;
        right: 48px;
        width: 30%;
        font-size: 20px;
        font-weight: 500;
        padding: 10px 10px 10px 80px;
        color: var(--text-500);
        background-color: transparent;
        @media (max-width: 1440px) {
          width: 60%;
        }
        @media (max-width: 1024px) {
          width: 80%;
        }
        @media (max-width: 1024px) {
          padding: 10px 0;
          font-size: 16px;
          font-weight: 700;
        }
        &.active {
          display: block;
          background-color: var(--bg-white);
          border: 1px solid var(--bg-gray);
        }
      }
    }
    .editIcon {
      direction: rtl;
      display: flex;
      align-items: center;

      img {
        cursor: pointer;
        /* margin-left: 16px; */
      }
    }
  }
  /* @media (max-width: 768px) {
    flex-direction: column;
  } */
`;

export const TextEditorWrapper = styled.div`
  & .toolbar-class {
    display: none;
  }
  & .editor-class {
    max-height: 640px;
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;
  }
  & .wrapper-class {
    color: var(--text-500);
    font-size: 16px;
    line-height: 27.64px;
    font-weight: 400;
    text-align: justify;
    @media (max-width: 1024px) {
      font-size: 14px;
    }
  }
`;
export const FeedBackDiv = styled.div`
  direction: rtl;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  margin-top: 16px;
  @media (max-width: 1024px) {
    flex-direction: row-reverse;
    margin-top: 40px;
  }
`;

export const Rating = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;
  .like {
    position: relative;
    overflow: hidden;
    .glass {
      width: 100%;
      height: 100%;
      cursor: pointer;
      z-index: 10;
      position: absolute;
    }
  }
  & p {
    font-size: 18px;
    font-weight: 500;
    color: var(--text-500);
  }
  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: var(--bg-white);
    box-shadow: 1px 2px 4px rgba(72, 86, 81, 0.1);
  }

  & div:nth-of-type(1) {
    /* margin-left: 16px; */
    &.active {
      background-color: var(--success-400);
      box-shadow: 1px 2px 4px rgba(72, 86, 81, 0.1);
      & svg {
        color: var(--bg-white);
      }
    }
    & svg {
      color: var(--success-200);
      width: 24px;
      height: 24px;
      cursor: pointer;
      &:hover {
        color: var(--success-500);
      }
    }
  }

  & div:nth-of-type(2) {
    &.active {
      background-color: var(--error-400);
      box-shadow: 1px 2px 4px rgba(72, 86, 81, 0.1);
      & svg {
        color: var(--bg-white);
      }
    }
    & svg {
      color: var(--error-200);
      width: 24px;
      height: 24px;
      cursor: pointer;
      &:hover {
        color: var(--error-500);
      }
    }
  }

  @media (max-width: 1024px) {
    width: 100%;
    justify-content: flex-end;
  }
  @media (max-width: 480px) {
    p {
      font-size: 15px;
    }
  }
`;

export const DownloadChangeButton = styled.div`
  display: flex;
  flex-direction: row-reverse;
  gap: 4px;
  /* margin-top: -2rem; */
  & button {
    display: inline-flex;
    width: 156px;
    height: 40px;
    font-size: 16px;
    font-weight: 700;
    color: var(--bg-disable);
    align-items: center;

    flex-direction: row-reverse;
    justify-content: space-between;
    @media (max-width: 1024px) {
      width: 150px;
      font-size: 14px;
    }
  }
  & div {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
  }
  @media (max-width: 1024px) {
    width: 100%;
    justify-content: flex-start;
    margin-bottom: 30px;
  }
`;

export const LoaderAudio = styled.div`
  display: flex;
  align-items: center;
  direction: rtl;
  width: 60%;
  justify-content: flex-start;
  & h4 {
    color: #89beff;
  }
`;

export const TextSuccess = styled.div`
  color: var(--text-500);
  font-size: 14px;
  font-weight: 700;
`;
